import smoothscroll from 'smoothscroll-polyfill'

const smoothScroller: (param: { to: string; extend?: number }) => void = ({ to, extend = -96 }) => {
  const targetElm = document.querySelector(to)
  if (targetElm) {
    const targetPos = window.pageYOffset + targetElm.getBoundingClientRect().top + extend
    smoothscroll.polyfill()
    window.scrollTo({
      top: targetPos,
      behavior: 'smooth',
    })
  }
}

export default smoothScroller
